import React from 'react';
import Modal from '../Modal/Modal';
import AddDocumentForm from './AddDocumentForm';
import { toastifyFn } from '../ReactToastify/ReactToastify';
import css from './AddDocumentModal.module.css';

const AddDocumentModal = props => {
  const {
    isAddDocument,
    onToggelAddDocument,
    onManageDisableScrolling,
    onUploadDocument,
    uploadInProgress,
    uploadedDocument,
    uploadError,
    onUploadDocumentInMongo,
    currentUser,
    updateDocumentInProgress,
    documnetUpdated,
    updateDocumentError,
    allGroupFolders,
    spaceDetail,
    intl
  } = props;

  const handleAddDoument = (values, form) => {

    const { documentName, folderId, document } = values;
    const payload = {
      folderId,
      documentName,
      groupId:spaceDetail?.id,
      userId: currentUser?.id?.uuid,
      ...document
    }
    onUploadDocumentInMongo(payload).then((response) => {
      onToggelAddDocument(false);
      form.restart()
      toastifyFn('success', 'Document uploaded successfully.');
    }).catch((e) => {
      console.log(e, '&&& &&& => e');
      toastifyFn('error', 'Oops! Something went wrong');
    });
  }

  return (
    <Modal
    className={css.addDocumentModalWrapper}
      id={'addDocumentModal'}
      isOpen={isAddDocument}
      onClose={() => onToggelAddDocument(false)}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <div>
        <AddDocumentForm
          onSubmit={(values, form) => handleAddDoument(values, form)}
          onUploadDocument={onUploadDocument}
          uploadInProgress={uploadInProgress}
          uploadedDocument={uploadedDocument}
          uploadError={uploadError}
          updateDocumentInProgress={updateDocumentInProgress}
          documnetUpdated={documnetUpdated}
          updateDocumentError={updateDocumentError}
          allGroupFolders={allGroupFolders}
          intl={intl}
        />
      </div>
    </Modal>
  );
};

export default AddDocumentModal;
